import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Button, ButtonGroup, ContentSection, Layout, SectionHeading } from '@vwfs-bronson/bronson-react';
import { VehicleType } from '../../../resources/base/models/vehicleTypes';
import { resetQuoteSpecificReduxData } from '../../../services/redux';
import { setIsCarUsed, setSelectedVehicleType } from '../../../services/redux/features/custom.slice';
import { useNavigate } from '../../../services/routing/navigate';

export const SelectCarType: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleVehicleTypeChange = (type: VehicleType) => {
    dispatch(setSelectedVehicleType(type));
    dispatch(setIsCarUsed(type === VehicleType.USED));

    if (type === VehicleType.NEW) {
      navigate.configurator();
    } else {
      navigate.form(1);
    }
  };

  return (
    <>
      <ContentSection pageWrap className="u-pv-none">
        <SectionHeading center level={2}>
          {t('step1:title')}
        </SectionHeading>
        <ButtonGroup buttonGroupType="radio">
          <ButtonGroup.Item
            buttonGroupItemIcon="car-configurator"
            onClick={() => handleVehicleTypeChange(VehicleType.NEW)}
            handle="new"
          >
            {t(`step1:carType:new`)}
          </ButtonGroup.Item>
          <ButtonGroup.Item
            buttonGroupItemIcon="car-key"
            handle="stock"
            onClick={() => handleVehicleTypeChange(VehicleType.STOCK)}
          >
            {t(`step1:carType:stock`)}
          </ButtonGroup.Item>
          <ButtonGroup.Item
            buttonGroupItemIcon="car"
            handle="used"
            onClick={() => handleVehicleTypeChange(VehicleType.USED)}
          >
            {t(`step1:carType:used`)}
          </ButtonGroup.Item>
        </ButtonGroup>
      </ContentSection>
      <ContentSection pageWrapSize="small">
        <Layout center>
          <Layout.Item default="1/3">
            <Button
              type="button"
              full
              secondary
              onClick={() => {
                resetQuoteSpecificReduxData();
                navigate.dashboardHome();
              }}
            >
              {t('step1:navigation:return')}
            </Button>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </>
  );
};
